// Utility to get user's public IP, country, and preferred language from IP
// Uses ipapi.co for geo lookup (no API key needed for basic info)

export async function getUserIPCountryLanguage() {
  try {
    const resp = await fetch('https://ipapi.co/json/');
    if (!resp.ok) return { ip: '', country: '', language: '' };
    const data = await resp.json();
    // ipapi returns: ip, country, country_code, languages (comma-separated, e.g. 'en,es')
    return {
      ip: data.ip,
      country: data.country_code,
      language: (data.languages || '').split(',')[0] // first preferred language
    };
  } catch (e) {
    return { ip: '', country: '', language: '' };
  }
}

// Map country code to app locale code
export function getLocaleForCountry(countryCode) {
  switch (countryCode) {
    case 'US':
    case 'GB':
    case 'CA':
    case 'AU':
      return 'en-US';
    case 'BR':
      return 'pt-BR';
    case 'MX':
    case 'AR':
    case 'CO':
    case 'CL':
    case 'PE':
    case 'VE':
    case 'EC':
    case 'GT':
    case 'CU':
    case 'BO':
    case 'DO':
    case 'HN':
    case 'PY':
    case 'SV':
    case 'NI':
    case 'CR':
    case 'PA':
    case 'UY':
      return 'es-419';
    default:
      return 'en-US'; // fallback
  }
}

// Check if IP is private (non-routable)
export function isPrivateIP(ip) {
  if (!ip) return true;
  return (
    ip.startsWith('10.') ||
    ip.startsWith('192.168.') ||
    (ip.startsWith('172.') && (() => {
      const n = parseInt(ip.split('.')[1], 10);
      return n >= 16 && n <= 31;
    })())
  );
}
